import React from "react";
import { Text } from "@chakra-ui/react";
export function Paragraph(props) {
    return React.createElement(Text, { fontSize: "md", maxWidth: "65ch", lineHeight: "tall", ...props });
}
